module.exports = require('./lib/index');



/*****************
 ** WEBPACK FOOTER
 ** ./~/symbol-observable/index.js
 ** module id = 269
 ** module chunks = 0
 **/